
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetomumbaicabs() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Cabs',
        heading: 'S9 Travels:  Pune to Mumbai Cabs',
        headingDescription: 'S9 Travels offers comfortable and reliable Pune to Mumbai cab services. Whether you’re traveling for business, a family vacation, or any other reason, our well-maintained fleet ensures a smooth, safe, and enjoyable ride. The journey from Pune to Mumbai is approximately 150 km and typically takes around 3 to 3.5 hours by road. With professional drivers, comfortable seating, and top-notch customer service, we ensure your trip is hassle-free from start to finish.',

        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "The Gateway of India is an iconic symbol of Mumbai. This majestic archway was built to commemorate the visit of King George V and Queen Mary in 1911. Located on the waterfront, it’s a perfect spot for photography and to take in the beautiful views of the Arabian Sea."
    },
    {
      "title": "Marine Drive",
      "description": "Marine Drive, also known as the Queen's Necklace, is a stunning boulevard that stretches along the coastline. It’s famous for its beautiful sunset views and is a popular place for an evening stroll, offering a great vantage point of the city's skyline."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "This UNESCO World Heritage Site is one of Mumbai's most famous landmarks. Known for its Victorian Gothic architectural style, CST is a historic railway station and a must-visit for history and architecture enthusiasts."
    },
    {
      "title": "Elephanta Caves",
      "description": "A short ferry ride from the city takes you to Elephanta Island, where you can explore ancient rock-cut caves with stunning sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and offer a blend of art, history, and natural beauty."
    },
    {
      "title": "Colaba Causeway",
      "description": "Colaba Causeway is a vibrant shopping street where you can find everything from clothes, jewelry, and antiques to local handicrafts. It’s also home to a range of cafes and restaurants, making it a popular spot for tourists and locals alike."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "This stunning bridge is an engineering marvel and offers panoramic views of the Arabian Sea and Mumbai’s skyline. A drive across the Bandra-Worli Sea Link is an unforgettable experience, especially during the evening when the bridge is beautifully lit."
    },
    {
      "title": "Juhu Beach",
      "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its relaxed atmosphere, food stalls, and lively crowds. It’s the perfect spot to enjoy a beach day, watch the sunset, or savor local street food like pav bhaji and bhel puri."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "The Haji Ali Dargah is a beautiful mosque and tomb located on an islet in the Arabian Sea. This iconic structure is both a spiritual and architectural marvel, offering a serene and peaceful experience for visitors."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "Escape the hustle and bustle of Mumbai and visit Sanjay Gandhi National Park, located on the outskirts of the city. The park offers a green oasis with walking trails, a lake, and the famous Kanheri Caves, providing an ideal retreat for nature lovers."
    },
    {
      "title": "Chor Bazaar",
      "description": "Known as the 'Thieves Market,' Chor Bazaar is a bustling street market in the heart of Mumbai. It’s the place to go if you’re looking for vintage items, antiques, or unique collectibles at bargain prices."
    }
],

"services": [
  {
    "name": "Book Pune to Mumbai Airport Innova Cab",
    "description": "Looking for reliable Pune to Mumbai cabs? Book an Innova cab for a smooth and comfortable airport transfer. Ideal for travelers who want convenience, space, and a stress-free ride."
  },
  {
    "name": "Pune to Mumbai Airport Innova Car Hire",
    "description": "Hire a spacious Innova for your Pune to Mumbai cabs journey. Whether heading to the airport or returning from a trip, our rentals offer the perfect balance of comfort and flexibility."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Service",
    "description": "Our Pune to Mumbai cabs provide professional service with trained drivers and well-maintained Innovas, ensuring a reliable and timely airport transfer every time."
  },
  {
    "name": "Pune to Mumbai Airport One-Way Innova",
    "description": "Need a one-way ride? Our Pune to Mumbai cabs include one-way Innova taxis, ideal for those looking for a direct, private ride to the airport without the hassle of return arrangements."
  },
  {
    "name": "Pune to Mumbai Airport Round Trip Innova",
    "description": "Book a round-trip with our Pune to Mumbai cabs in an Innova. Enjoy peace of mind with a secure ride to the airport and a reliable return after your trip."
  },
  {
    "name": "Mumbai Airport to Pune Innova",
    "description": "Arriving at the airport? Our Pune to Mumbai cabs also operate in reverse, offering Innova pickups from Mumbai Airport to Pune with real-time flight tracking and punctual service."
  },
  {
    "name": "Mumbai Airport Innova Taxi Booking",
    "description": "Book your Innova cab easily for airport trips. Our Pune to Mumbai cabs service covers one-way, round-trip, and hourly options to suit your travel needs."
  },
  {
    "name": "Affordable Pune to Mumbai Airport Innova",
    "description": "Travel in comfort without overspending. Our Pune to Mumbai cabs offer affordable Innova options that are spacious, reliable, and perfect for any kind of airport travel."
  },
  {
    "name": "Mumbai to Pune Innova Cab",
    "description": "Flying into Mumbai? Book one of our Pune to Mumbai cabs for a smooth ride back. Our Innova cabs ensure you get home comfortably after your flight."
  },
  {
    "name": "Luxury Innova for Mumbai Airport",
    "description": "Upgrade your Pune to Mumbai cabs experience with our luxury Innova options. Enjoy extra legroom, premium interiors, and a smoother ride — ideal for executives or special occasions."
  },
  {
    "name": "Mumbai to Pune One-Way Innova",
    "description": "Our Pune to Mumbai cabs also serve one-way trips from Mumbai Airport to Pune. Ride in a spacious Innova and enjoy a direct and relaxing transfer after your flight."
  },
  {
    "name": "Private Innova Cab from Pune to Mumbai Airport",
    "description": "Prefer privacy while traveling? Choose our Pune to Mumbai cabs with private Innova vehicles for a peaceful and personal ride to the airport."
  },
  {
    "name": "Group Travel to Mumbai Airport by Innova",
    "description": "Our Pune to Mumbai cabs are perfect for group travel. Book an Innova for airport transfers and enjoy roomy seating and enough space for all your luggage."
  },
  {
    "name": "Book Innova for Mumbai Airport Pickup",
    "description": "Need an airport pickup? Book our Pune to Mumbai cabs with Innova service for timely pickups from Mumbai Airport and a safe return to Pune."
  }
],
  "tableData": [
    ["Book Pune to Mumbai Airport Innova Cab", "Pune to Mumbai Airport Innova Car Hire"],
    ["Pune to Mumbai Airport Taxi Service", "Pune to Mumbai Airport One-Way Innova"],
    ["Pune to Mumbai Airport Round Trip Innova", "Mumbai Airport to Pune Innova"],
    ["Mumbai Airport Innova Taxi Booking", "Affordable Pune to Mumbai Airport Innova"],
    ["Mumbai to Pune Innova Cab", "Luxury Innova for Mumbai Airport"],
    ["Mumbai to Pune One-Way Innova", "Private Innova Cab from Pune to Mumbai Airport"],
    ["Group Travel to Mumbai Airport by Innova", "Book Innova for Mumbai Airport Pickup"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important it is to catch your flight on time. We ensure prompt pickups from your location in Pune and a smooth drive to Mumbai Airport. Our drivers are punctual and committed to making sure you reach the airport well in advance for your flight."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "The Toyota Innova is perfect for long journeys like Pune to Mumbai Airport. With comfortable seating, air conditioning, and ample space for luggage, our Innova cabs provide a relaxing and stress-free travel experience. Whether you’re traveling alone or with family or friends, you’ll enjoy a comfortable ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and well-versed with the best routes from Pune to Mumbai Airport. They are punctual, courteous, and knowledgeable, ensuring a smooth and hassle-free journey. We prioritize your comfort and safety, so you can relax during your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Mumbai Airport Innova booking. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. We make sure you enjoy a secure and comfortable ride throughout the journey to Mumbai Airport."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter what time your flight is, S9 Travels is available 24/7. Whether you have an early morning flight or a late-night arrival, we will ensure that your ride is ready when you need it. Our customer service team is also available around the clock to assist you with your bookings."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Mumbai Airport Innova cab is simple and convenient with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in booking your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific requirements or need additional services for your journey, we offer customized travel packages. Whether it’s a direct drop to the airport or a stop for refreshments along the way, we tailor the trip to meet your needs."
  }
]








    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Mumbai with S9 Travels?',
            answer: 'Booking a cab for your Pune to Mumbai trip is simple! You can book online through our website or mobile app, or contact our customer service team for personalized assistance.'
          },
          {
            question: 'What types of cabs are available for Pune to Mumbai travel?',
            answer: 'We offer a range of cabs, including the spacious Toyota Innova, perfect for families, groups, and anyone needing extra luggage space.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Mumbai route?',
            answer: 'Yes, our drivers are well-trained and experienced, familiar with the best routes between Pune and Mumbai to ensure a smooth and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Mumbai?',
            answer: 'You can pay through various options such as cash, credit/debit cards, or secure online payments via our mobile app.'
          },
          {
            question: 'Can I book a round trip from Pune to Mumbai?',
            answer: 'Yes, we offer round-trip bookings. Simply provide your return details, and we’ll arrange your return ride from Mumbai to Pune.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Extra charges for detours or waiting time, if applicable, will be communicated to you upfront, ensuring full transparency.'
          },
          {
            question: 'Can I make additional stops on the way from Pune to Mumbai?',
            answer: 'Yes, you can make additional stops. Please inform us during the booking process, and we will accommodate your requests.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Mumbai trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know when booking.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for the Pune to Mumbai route?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Mumbai. Our vehicles are comfortable, and our drivers are professional.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Mumbai cab booking?',
            answer: 'S9 Travels ensures a reliable, comfortable, and stress-free ride. With professional drivers, well-maintained vehicles, and excellent customer service, we guarantee a pleasant journey to Mumbai.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ramesh Kumar',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Pune to Mumbai with S9 Travels, and the experience was exceptional. The driver was punctual, the car was clean, and the journey was smooth. I highly recommend S9 Travels for anyone looking for a comfortable ride!”'
        },
        {
          name: 'Mrs. Neha Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip from Pune to Mumbai, and the service was fantastic. The vehicle was spacious and comfortable, and the driver was professional. I’ll definitely book again for our next trip!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      
//   const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune to Mumbai Cabs",
//   "image": "/images/keyword/86.jpg",
//   "description": "Book trusted Pune to Mumbai cabs with S9 Travels for a smooth and affordable journey. We offer one-way, round-trip, and luxury cab services with AC sedans, SUVs, and premium cars. Enjoy on-time pickups, professional drivers, and flexible schedules for seamless travel between Pune and Mumbai.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "8921"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2499",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/Pune-to-Mumbai-Cabs"
//   }
// };

    
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service – S9 Travels",
  "image": "https://www.s9travels.com/images/keyword/86.jpg",
  "description": "Book reliable Pune to Mumbai cab services with S9 Travels. Affordable fares from ₹2,499 with Hatchback, Sedan, SUV & Innova Crysta options. Enjoy one-way trips, Mumbai airport transfers, and round journeys with trained drivers, on-time pickups, and instant online booking.",
  "brand": { "@type": "Brand", "name": "S9 Travels" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7832"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/Pune-to-Mumbai-Cabs"
  }
};




    
      


    return (
        <div>

      

<Helmet>
  <title>Pune to Mumbai Cabs from ₹2,499 | Airport Drop, One-Way Taxi & Outstation | S9 Travels</title>
  <meta
    name="description"
    content="Hire Pune to Mumbai cabs at affordable fares from ₹2,499. Book one-way taxi, round-trip cab, or Mumbai airport drop with S9 Travels. Choose AC Hatchback, Sedan, SUV & Innova Crysta with professional drivers, on-time pickup, and instant confirmation."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Cabs, Pune to Mumbai Taxi, Pune to Mumbai Airport Drop, One Way Cab Pune to Mumbai, Round Trip Pune to Mumbai Taxi, Sedan Cab Pune to Mumbai, SUV Cab Pune to Mumbai, Innova Pune to Mumbai Cab, Pune to Mumbai Car Hire, Online Cab Booking Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

{ /*
By this comment code page is Ranking on 7th page 
/*}

    {/* <Helmet>
  <title>Pune to Mumbai Cabs | S9 Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai cabs online with S9 Travels. Get the best rates for one-way or round-trip taxi services with well-maintained cars, trained drivers, and timely pickups. Choose from hatchbacks, sedans, SUVs, and luxury cabs for a comfortable journey." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Cabs, Pune to Mumbai Taxi, One Way Cab from Pune to Mumbai, Round Trip Pune to Mumbai Cab, Pune Mumbai Cab Fare, Online Cab Booking Pune to Mumbai, Luxury Cab Pune to Mumbai, AC Cabs from Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}

      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicabs;